import { render, staticRenderFns } from "./MarginHelpPopups.vue?vue&type=template&id=a67c0290&scoped=true&"
import script from "./MarginHelpPopups.vue?vue&type=script&lang=js&"
export * from "./MarginHelpPopups.vue?vue&type=script&lang=js&"
import style0 from "./MarginHelpPopups.vue?vue&type=style&index=0&id=a67c0290&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67c0290",
  null
  
)

export default component.exports